<template>
  <ActionButton
    ref="actionButton"
    action="review"
    icon="done_all"
    :text="text"
    :title="title"
    :confirm="confirm"
    :size="size"
    :css="css"
    @clickAction="reviewFindings()"
  />
</template>

<script>
import ActionButton from "../shared/action_button";

export default {
  components: {
    ActionButton
  },

  props: {
    inspectionId: String,
    projectId: String,
    text: {
      type: String,
      default: 'Review Findings'
    },
    title: {
      type: String,
      default: 'Review All Findings'
    },
    confirm: {
      type: String,
      default: 'All Findings will be reviewed?'
    },
    size: {
      type: String,
      default: 'sm'
    },
    css: {
      type: String,
      default: ''
    }
  },

  methods: {
    reviewInspectionFindings: function() {
      this.$refs.actionButton.isSpinnerVisible = true;

      app.graphql.get(
        "update.inspection.reviewFindings",
        {
					input: {
						inspectionId: this.inspectionId
					}
        },
    
        (data) => {
        	const response = data.data.reviewInspectionFindings;
    
					if (response.errors) {
						response.errors.forEach((error) => {
							app.ui.toast.add({
								priority: "warning",
								title: "Unable to update finding",
								message: error
							});

              this.$refs.actionButton.isSpinnerVisible = false;
          	});
        	} else {
						app.ui.toast.add({
							priority: "success",
							title: "Inspection Findings",
							message: "All inspection findings from <strong>review</strong> status set to <strong>reviewed</strong>"
						});

            setTimeout(() => {
              this.$refs.actionButton.isSpinnerVisible = false;

              this.$emit("reviewed");
            }, 1000);
					}
        }
			);
    },

    reviewProjectFindings: function() {
      this.$refs.actionButton.isSpinnerVisible = true;

			app.graphql.get(
        "update.project.reviewFindings",
        {
					input: {
						projectId: this.projectId
					}
        },
    
        (data) => {
        	const response = data.data.reviewProjectFindings;
    
					if (response.errors) {
						response.errors.forEach((error) => {
							app.ui.toast.add({
								priority: "warning",
								title: "Unable to update finding",
								message: error
							});

              this.$refs.actionButton.isSpinnerVisible = false;
          	});
        	} else {
						app.ui.toast.add({
							priority: "success",
							title: "Project Findings",
							message: "All project findings from <strong>review</strong> status set to <strong>reviewed</strong>"
						});

            setTimeout(() => {
              this.$refs.actionButton.isSpinnerVisible = false;

              this.$emit("reviewed");
            }, 1000);
					}
        }
			);
    },

    reviewFindings: function() {
      if (this.inspectionId) {
        this.reviewInspectionFindings()
      }

      if (this.projectId) {
        this.reviewProjectFindings()
      }
      
    }
  }
}
</script>
